var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2704_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.333 512C218.437 512 256.667 473.771 256.667 426.667V341.333H171.333C124.229 341.333 86 379.563 86 426.667C86 473.771 124.229 512 171.333 512Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 256C86 208.896 124.229 170.667 171.333 170.667H256.667V341.333H171.333C124.229 341.333 86 303.104 86 256Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 85.3333C86 38.2293 124.229 0 171.333 0H256.667V170.667H171.333C124.229 170.667 86 132.437 86 85.3333Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.667 0H342C389.104 0 427.333 38.2293 427.333 85.3333C427.333 132.437 389.104 170.667 342 170.667H256.667V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.333 256C427.333 303.104 389.104 341.333 342 341.333C294.896 341.333 256.667 303.104 256.667 256C256.667 208.896 294.896 170.667 342 170.667C389.104 170.667 427.333 208.896 427.333 256Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2704_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.f3d3bf2d9f2f132e92677151de016c72.svg";
export { ForwardRef as ReactComponent };